<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        title="英語化問診票作成： 問診内容を入力する"
        hide-footer
        @hidden="close">
        <div
            v-if="transQuestions === null"
            class="d-flex justify-content-center align-items-center pt-5 pb-5">
            <b-spinner variant="yokumiru-user"></b-spinner>
        </div>
        <div v-else class="mb-3">
            <div class="mb-3">{{ medicalCourse.name }}の英語化問診票を作成します。<br>下記の項目を記入してください。</div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>セイ</label>
                        <input
                            :value="user.last_name_kana"
                            type="text"
                            class="form-control"
                            disabled>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>メイ</label>
                        <input
                            :value="user.first_name_kana"
                            type="text"
                            class="form-control"
                            disabled>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>生年月日</label>
                        <input
                            :value="helper.birthdayForHuman(user.birthday)"
                            type="text"
                            class="form-control"
                            disabled>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>性別</label>
                        <input
                            :value="user.sex ? '女性' : '男性'"
                            type="text"
                            class="form-control"
                            disabled>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>身長</label>
                        <div class="input-group">
                            <input
                                :value="user.height || '-'"
                                type="text"
                                class="form-control"
                                disabled>
                            <div class="input-group-append">
                                <span class="input-group-text">cm</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>体重</label>
                        <div class="input-group">
                            <input
                                :value="user.weight || '-'"
                                type="text"
                                class="form-control"
                                disabled>
                            <div class="input-group-append">
                                <span class="input-group-text">kg</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>血液型</label>
                        <div class="input-group">
                            <input
                                :value="user.blood || '-'"
                                type="text"
                                class="form-control"
                                disabled>
                            <div class="input-group-append">
                                <span class="input-group-text">型</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>体温</label>
                        <div class="input-group">
                            <input
                                v-model="bodyTemperature"
                                type="text"
                                class="form-control">
                            <div class="input-group-append">
                                <span class="input-group-text">℃</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-for="( q, idx ) in transQuestions">
                <label :class="{ 'is-required-ja' : q.flg_required === 1 }">{{ q.title }}</label>

                <div class="mb-3">
                    <template v-if="Number( q.interview_question_type_id ) === questionTypes.input">
                        <input
                            v-model="q.content"
                            type="text"
                            class="form-control"
                            :class="{ 'is-invalid' : detectError( 'trans_questions', idx ) || q.content && q.content.length > 255 }"
                            :id="`q-${q.id}`">
                    </template>

                    <template v-else-if="Number( q.interview_question_type_id ) === questionTypes.multiInput">
                            <textarea
                                v-model="q.content"
                                class="form-control"
                                :class="{ 'is-invalid' : detectError( 'trans_questions', idx ) || q.content && q.content.length > 500 }"
                                :id="`q-${q.id}`">
                            </textarea>
                    </template>

                    <template v-else-if="Number( q.interview_question_type_id ) === questionTypes.radio">
                        <div v-for="item in q.items" class="form-check">
                            <input
                                v-model="q.content"
                                :value="item.title"
                                type="radio"
                                class="form-check-input"
                                :id="`q-${q.id}-item-${item.id}`">
                            <label
                                class="form-check-label"
                                :for="`q-${q.id}-item-${item.id}`">
                                {{ item.title }}
                            </label>
                        </div>

                        <div v-if="Number( q.flg_other ) === 1" class="form-check">
                            <input
                                v-model="q.content"
                                value="その他"
                                type="radio"
                                class="form-check-input"
                                :id="`q-${q.id}-item-other`">
                            <label
                                class="form-check-label"
                                :for="`q-${q.id}-item-other`">
                                その他
                            </label>
                        </div>
                    </template>

                    <template v-else-if="Number( q.interview_question_type_id ) === questionTypes.check">
                        <div v-for="item in q.items" class="form-check">
                            <input
                                v-model="q.content"
                                :value="item.title"
                                type="checkbox"
                                class="form-check-input"
                                :id="`q-${q.id}-item-${item.id}`">
                            <label
                                class="form-check-label"
                                :for="`q-${q.id}-item-${item.id}`">
                                {{ item.title }}
                            </label>
                        </div>

                        <div v-if="Number( q.flg_other ) === 1" class="form-check">
                            <input
                                v-model="q.content"
                                value="その他"
                                type="checkbox"
                                class="form-check-input"
                                :id="`q-${q.id}-item-other`">
                            <label
                                class="form-check-label"
                                :for="`q-${q.id}-item-other`">
                                その他
                            </label>
                        </div>
                    </template>

                    <div
                        v-if="!hasLengthValidateMessage( 'trans_questions', idx )"
                        class="invalid-feedback d-block mt-1">
                        {{ validateMessage( 'trans_questions', idx ) }}
                    </div>

                    <template v-if="Number( q.interview_question_type_id ) === questionTypes.input">
                        <div
                            class="d-flex justify-content-between text-muted small mt-1"
                            :class="{ 'is-invalid-color' : q.content && q.content.length > 255 }">
                            <div>255文字以内で回答してください</div>
                            <div>{{ q.content !== null ? q.content.length : 0 }}/255</div>
                        </div>
                    </template>
                    <template v-else-if="Number( q.interview_question_type_id ) === questionTypes.multiInput">
                        <div
                            class="d-flex justify-content-between text-muted small mt-1"
                            :class="{ 'is-invalid-color' : q.content && q.content.length > 500 }">
                            <div>500文字以内で回答してください</div>
                            <div>{{ q.content !== null ? q.content.length : 0 }}/500</div>
                        </div>
                    </template>
                </div>
            </div>

            <div class="invalid-feedback d-block mt-1" v-if="errors.message">
                {{ errors.message[0] }}
            </div>

            <b-button
                class="nextButton"
                :disabled="inProgress"
                @click="handleOk">
                確認画面へ進む
            </b-button>
        </div>
    </b-modal>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'
    import constants from '../../../constants'
    import { mapMutations } from 'vuex'

    export default {
        data: function () {
            return {
                helper: YokumiruHelper,
                inProgress: false,
                modalShow: false,
                user: null,
                bodyTemperature: null,
                medicalCourse: null,
                transQuestions: null,
                questionTypes: constants.interview_question_types,
                errors: {},
            }
        },

        created: function() {
            bus.$on('open-modal-user-interview-trans-questions', this.open)
            bus.$on('user-interview-trans-completed', this.close)
        },

        beforeDestroy: function() {
            bus.$off('open-modal-user-interview-trans-questions')
            bus.$off('user-interview-trans-completed')
        },

        methods: {
            ...mapMutations({
                setUser: 'userInterviewTransAnswers/setUser',
                setBodyTemperature: 'userInterviewTransAnswers/setBodyTemperature',
                setMedicalCourse: 'userInterviewTransAnswers/setMedicalCourse',
                setTransQuestions: 'userInterviewTransAnswers/setTransQuestions',
            }),

            /**
             * モーダル表示
             * @param {object} medicalCourse
             * @param {object} user
             */
            open: function (medicalCourse, user) {
                this.modalShow = true
                this.user = { ...user }
                this.medicalCourse = medicalCourse
                this.fetchInterviewQuestions()
            },

            /**
             * モーダル非表示
             */
            close: function() {
                this.modalShow = false
            },

            /**
             * 問診取得
             */
            fetchInterviewQuestions: async function () {
                this.transQuestions = null
                const endpoint = constants.user.medical_courses.endpoint.base

                await axios.get(`${endpoint}/${this.medicalCourse.id}/interview_trans_questions`)
                    .then(({data}) => {
                        this.transQuestions = data.data
                    })
            },

            /**
             * 問診エラーメッセージ表示
             */
            detectError: function ( attribute, idx ) {
                const self = this;

                const filtered = Object.keys( self.errors )
                    .filter( key => key === `${attribute}.${idx}` );

                return filtered.length > 0;
            },

            /**
             * 問診エラーメッセージ表示
             */
            validateMessage: function (attribute, idx) {
                const filtered = Object.keys(this.errors)
                    .filter(key => key === `${attribute}.${idx}`)
                    .map(key => this.errors[key][0])

                return filtered ? filtered[0] : null
            },

            /**
             * 文字数制限のエラーメッセージ判定
             */
            hasLengthValidateMessage: function (attribute, idx) {
                const result = this.validateMessage(attribute, idx)
                if (!result) return false

                return result.includes('255') || result.includes('500')
            },

            /**
             * 「確認画面へ進む」ボタン押下時
             * @param {object} e
             */
            handleOk: async function(e) {
                e.preventDefault()

                if (this.inProgress) return
                this.inProgress = true

                const params = {
                    trans_questions: this.transQuestions,
                    body_temperature: this.bodyTemperature,
                    confirm: 1,
                }
                const endpoint = constants.user.medical_courses.endpoint.base

                await axios.post(`${endpoint}/${this.medicalCourse.id}/interview_trans_answers`, params)
                    .then(({data}) => {
                        this.errors = {}
                        this.setUser(this.user)
                        this.setBodyTemperature(this.bodyTemperature)
                        this.setMedicalCourse(this.medicalCourse)
                        this.setTransQuestions(this.transQuestions)
                        bus.$emit('open-modal-user-interview-trans-questions-confirm')
                    })
                    .catch( ({response}) => {
                        this.errors = response.data.errors
                        bus.$emit('alert-danger')
                    })

                this.inProgress = false
            },
        },
    }
</script>

<style lang="scss" scoped>
.prevButton,
.nextButton {
    display: block;
    width: 210px;
    height: 42px;
    line-height: 42px;
    padding: 0;
    margin: 0 auto;
    color: #fff;
    font-weight: bold;
    text-align: center;
    background-color: #CF798A;
    border: none;
    border-radius: 8px;
    cursor: pointer;
}

.prevButton {
    color: #333;
    background-color: #D9D9D9;
}
</style>
